import Vue from "vue";
//https://www.npmjs.com/package/vue-socket.io
//https://www.npmjs.com/package/vue-socket.io-extended
import VueSocketIOExt from "vue-socket.io-extended";
import io from "socket.io-client";
let endpoint = global.config.endpoint;
if (global.config.socketioport) {
  endpoint = endpoint.split("/")[2];
  endpoint = "http://" + endpoint + ":" + global.config.socketioport;
}
const socket = io(endpoint);
Vue.use(VueSocketIOExt, socket);
